const theme = {
    sidebar: {
        variant: {
            admpanel: {
                textColor: 'white',
                titleFontSize: 'v_12',
                separatorLineColor: 'blue_300',
                backgroundColor: 'gray_800',
                backgroundSubMenu: '#6086d0',
                backgroundActiveMenu: 'blue_300'
            }
        }
    }
};

export default theme;
